import { render } from "./Contribute.vue?vue&type=template&id=79da808e&scoped=true"
import script from "./Contribute.vue?vue&type=script&lang=js"
export * from "./Contribute.vue?vue&type=script&lang=js"

import "./Contribute.vue?vue&type=style&index=0&id=79da808e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79da808e"]])

export default __exports__